import { Fragment } from "react";

const SIZE_RX = /(\d{1,3}(?:[.,]\d)?\s*[x×X]\s*\d{1,3}(?:[.,]\d)?(?:\s*mm)?|[Øø]\s*\d{1,3}(?:[.,]\d)?(?:\s*mm)?|diametro\s*(?:di\s*)?\d{1,3}(?:[.,]\d)?(?:\s*mm)?)/gi;

export function SizeText({ text }) {
  const parts = String(text || "").split(SIZE_RX);
  return parts.map((t, i) => (i % 2 ? <mark key={i} className="size-mark">{t}</mark> : <Fragment key={i}>{t}</Fragment>));
}

const esc = (s) => s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function highlightHtml(html) {
  const src = /<[a-z]/i.test(html || "") ? html : esc(html || "").replace(/\n/g, "<br>");
  let inMark = 0;
  return src.split(/(<[^>]+>)/g).map((seg) => {
    if (seg.startsWith("<")) {
      if (/^<mark/i.test(seg)) inMark++;
      if (/^<\/mark/i.test(seg)) inMark = Math.max(0, inMark - 1);
      return seg;
    }
    return inMark ? seg : seg.replace(SIZE_RX, '<mark class="size-mark">$1</mark>');
  }).join("");
}

export function RichDescription({ html, className = "", testid }) {
  if (!html) return null;
  // eslint-disable-next-line react/no-danger
  return <div data-testid={testid} className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: highlightHtml(html) }} />;
}
